import { TDispatch, useAppDispatch, useAppSelector, ws_manager } from 'Store/index';
import { getVisitedPatients, IPatientNames } from 'Store/session/apiFetchers';
import { take } from 'Utility/ramdaReplacement';
import SearchResults from '../components/SearchResults';
import { jwtModify, patientSelect } from '../fetchers';
import { clearAllPatientDataAndSettings } from 'Store/combinedActions';
import { actions } from 'Store/session';
import { useIntl } from 'react-intl';
import { StyledHeader } from '../components';
import * as React from 'react';

const fetchNewJWT = (res: Response, dispatch: TDispatch): void => {
  if (res.status === 200) {
    void res.text().then((text: string) => {
      void jwtModify(text).then(success => {
        if (success) {
          dispatch(actions.loadSession());
          dispatch(clearAllPatientDataAndSettings());
        }
      });
    });
  }
};

const moveToVisitFromSearch = (id: string, dispatch: TDispatch): void => {
  const patientid = id;
  if (patientid) {
    void patientSelect(patientid).then(res => res && fetchNewJWT(res, dispatch));
  }
};

const PreviousPatients = () => {
  const [visitedPatients, setVisitedPatients] = React.useState<IPatientNames[]>([]);
  React.useEffect(() => {
    void getVisitedPatients().then(res => {
      if (res) {
        setVisitedPatients(res);
      }
    });
  }, []);

  let visitedPatientsList = visitedPatients;
  const visitedLimit = useAppSelector(s => s.settings.userSettings.latestPatientsNumber);
  const visitedDate = useAppSelector(s => s.settings.userSettings.latestPatientsDate);
  if (typeof visitedLimit === 'number') visitedPatientsList = take(visitedLimit, visitedPatientsList);
  if (typeof visitedDate === 'number') {
    const thisDate = new Date();
    thisDate.setDate(thisDate.getDate() - visitedDate);
    visitedPatientsList = visitedPatientsList.filter(vis => {
      return vis.timestamp >= thisDate.valueOf();
    });
  }

  const dispatch = useAppDispatch();
  const { formatMessage } = useIntl();
  const fm = (id: string) => formatMessage({ id });

  return (
    <div style={{ width: '50%' }}>
      <StyledHeader>{fm('general.previousPatients')}</StyledHeader>
      <SearchResults
        searchResults={visitedPatientsList.map(pat => {
          const neuroUserArray = {
            ...pat,
            ssn: pat.ssn || '',
            firstNames: pat.firstNames || '',
            lastNames: pat.lastNames || '',
          };
          return neuroUserArray;
        })}
        onClickResult={id => {
          ws_manager.disconnect();
          id && moveToVisitFromSearch(id, dispatch);
        }}
        limit={25}
        displayTopHeader={false}
        alternateColoring={true}
        secondaryStyle={false}
        noSortByName={true}
      />
    </div>
  );
};

export default PreviousPatients;
